import { type StateStorage } from "zustand/middleware";
import { get, set, del } from "idb-keyval";

// Custom storage object
export const storage: StateStorage = {
  getItem: async (name: string): Promise<string | null> => {
    // console.log(name, "has been retrieved");
    if (!(await get(name))) {
      set(name, "[]");
      return "[]";
    }

    return (await get(name)) || "[]";
  },
  setItem: async (name: string, value: string): Promise<void> => {
    // console.log(name, "with value", value, "has been saved");
    await set(name, value);
  },
  removeItem: async (name: string): Promise<void> => {
    // console.log(name, "has been deleted");
    await del(name);
  },
};
